/**
 * Projects Module
 * Project management, form builder, and workflow automation
 */

import type { Module } from '../../index';
import { projectsRoutes } from './routes/config';

// Export components
export * from './components';

// Export lib
export * from './lib/types';

// Export pages
export { default as Dashboard } from './pages/Dashboard';
export { default as ProjectManagement } from './pages/ProjectManagement';
export { default as FormBuilder } from './pages/FormBuilder';
export { default as WorkflowBuilder } from './pages/WorkflowBuilder';

/**
 * Projects Module Definition
 */
const projectsModule: Module = {
  name: 'projects',
  path: '/app/projects',
  routes: projectsRoutes,
  components: {
    // Export any shared components here
  },
  services: {
    // Export any shared services here
  },
};

export default projectsModule;
